<template>
  <div class="formAddDocs">
    <div class="d-flex justify-content-end pt-2 border-top">
      <div class="d-inline-block">
        <button v-if="!showForm"
                id="add_img"
                class="btn btn-sm btn-primary"
                type="button"
                @click="toggleForm">
          <IconSvg icon="add"
                   class="icon--xxs mb-1" />
          Adicionar
        </button>
      </div>
    </div>

    <form v-if="showForm"
          class="boxAddDocs"
          name="formAddDocs"
          novalidate>
      <div class="boxAddDocs_header">
        <h2 class="boxAddDocs_header_title">
          Nova imagem
        </h2>
      </div>

      <div class="boxAddDocs_content">
        <div class="row">
          <div class="col">
            <div class="form-group mb-1">
              <select id="perfil"
                      v-model="selectProfile"
                      v-validate="'required'"
                      class="custom-select custom-select-sm"
                      name="perfil">
                <option v-for="item in profiles"
                        :key="item.id"
                        :value="item.id">
                  {{ item.desc }}
                </option>
              </select>
              <small v-if="errors.has('perfil')"
                     class="invalid-feedback">{{ errors.first('perfil') }}</small>
            </div>
          </div>

          <div class="col">
            <!--:disabled="(perfil === null || (isUploading || uploadComplete))"-->
            <file-upload class="w-100 mb-sm-0 mb-4"
                         :label="(selectedFiles.length ? inputLabel: 'Buscar arquivo')"
                         :sm="true"
                         :btn="false"
                         @onSelectFiles="onSelectFiles" />
          </div>
        </div>

        <div class="row mt-1">
          <div class="col-2 boxAddDocs--display-flex">
            <span class="boxAddDocs--self-flex-end mb-1">
              <b-form-checkbox
                v-model="flag_isento"
                switch
                :value="true"
                :disabled="!selectProfile"
                @keyup.native.enter="flag_isento = !flag_isento">
                Isento
              </b-form-checkbox>
            </span>
          </div>
          <div v-if="[6,7,8,9,10].indexOf(selectProfile) != -1"
               class="col-3">
            <label>
              Data de Averbação
            </label>
            <input
              v-model="data_documento"
              v-mask="'##/##/####'"
              v-validate="{ required: !!flag_isento }"
              class="form-control form-control-sm"
              name="data_documento"
              :class="{ 'is-invalid': errors.has('data_documento') }"
              type="text">
            <small v-if="errors.has('data_documento')"
                   class="invalid-feedback">{{ errors.first('data_documento') }}</small>
          </div>
        </div>
        <div class="row no-gutters justify-content-end">
          <div class="d-inline-block mt-2">
            <button class="btn btn-sm btn-danger mr-1"
                    type="button"
                    @click="toggleForm">
              Cancelar
            </button>

            <button class="btn btn-sm btn-primary mr-1"
                    :disabled="!selectedFiles.length"
                    type="button"
                    @click="submitFiles">
              Importar
            </button>

            <!-- <button class="btn btn-sm btn-secondary"
                    :disabled="!selectedFiles.length || selectProfile !== 1"
                    type="button"
                    @click="submitAndSignerFiles">
              Importar e assinar
            </button> -->
          </div>
        </div>
      </div>
    </form>

    <b-modal ref="modalCertificados"
             hide-footer
             title="Selecione um certificado"
             size="lg">
      <grid-certificados v-if="certificados && certificados.length > 0"
                         :certificados="certificados"
                         @onSelectCertificado="onSelectCertificado" />
    </b-modal>
  </div>
</template>

<script>
  /* components */
  import IconSvg  from "@/components/IconSvg"

  /* services */
  import BryService from '@/services/Assinaturas/BryService'
  import FileUploadService from "@/services/Arquivos/FileUploadService"

  /* helpers */
  import PerfilRegistroHelper from "@/helpers/Registros/PerfilRegistroHelper"

  /* constants */
  import objSwal from '@/constants/swalValues'
  import { STATUS_PENDING, STATUS_ERROR } from '@/constants/fileUpload'

  /* outros */
  import GridCertificados from '../../GridCertificados'
  import FileUpload from '../Upload/FileUpload'
  import Swal from 'sweetalert2'
  import { mapGetters } from 'vuex'

  export default {
    name: "FormAddDocs",
    components: {
      FileUpload,
      GridCertificados,
      IconSvg
    },
    props: {
      perfil: { type: String, default: () => "" },
      registroId: { type: Number, required: true }
    },
    data () {
      return {
        profiles: [],
        assinando: false,
        showForm: false,
        selectProfile: null,
        uploadedFilesCount: 0,
        inputLabel: '',
        selectedFiles: [],
        isUploading: false,
        certificados: null,
        certificadoSelecionado: null,
        fileObj: null,
        objBase64: null,
        assinatura: null,
        flag_isento: false,
        data_documento: null
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId'
      }),
    },
    mounted () {
      this.profiles = PerfilRegistroHelper.getPerfilGED(this.perfil)
      this.selectProfile = this.profiles[1].id
    },
    methods: {
      toggleForm () {
        this.showForm = !this.showForm
        if (this.showForm) return
        this.selectedFiles = []
        this.inputLabel = ''
      },
      onSelectFiles (files) {
        objSwal.error.title = ''
        objSwal.error.text = 'Selecione apenas uma imagem.'
        if (files.length > 1) {
          return Swal.fire(objSwal.error)
        }

        for (let i = 0; i < files.length; i++) {
          this.inputLabel = files[i].name

          this.selectedFiles.push({
            status: STATUS_PENDING,
            file: files[i],
            registro_id: this.registroId,
            codigo_perfil_ged: this.selectProfile,
            flag_isento: this.flag_isento,
            cartorio_id: this.$store.state.auth.cartorio_id,
            data_documento: this.data_documento
          })
        }

        this.fileObj = this.selectedFiles[0]
      },
      onSelectCertificado (certificado) {
        this.certificadoSelecionado = certificado
        // Fechando modal
        this.$refs.modalCertificados.hide()
        // Anulando certificados obtidos
        this.certificados = null
        // Fazendo upload dos arquivos
        return this.submitFiles()
      },

      async submitAndSignerFiles () {
        this.assinando = true

        // Upload
        await this.obterCertificados()
      },
      submitFiles () {
        this.$validator.validate().then(async resp => {
          if (resp) {
            try {
              this.startsSignOrImport('Importando...')
              this.fileObj.codigo_perfil_ged = this.selectProfile
              this.fileObj.flag_isento = this.flag_isento

              if (this.data_documento) this.fileObj.data_documento = this.data_documento

              const upload = await FileUploadService.uploadSofiaRei(this.fileObj)

              const { documento } = upload.data
              if (this.assinando && this.certificadoSelecionado) {
                await this.assinarDocumentos(documento.documento_id)
              }

              NProgress.done()
              this.$store.dispatch('auth/loader', { text: '', active: false }).then(()=> {})
              this.showForm = false
              this.fileObj = null
              this.flag_isento = null
              this.data_documento = null
              this.selectedFiles = []

              return this.$emit('uploadDone', upload.data)

            } catch (error) {
              this.errorSwal(error)
            }
          }
        })
      },
      async obterCertificados () {
        if (!BryService.isExtensionInstalled()) {
          this.onError('', 'Certificados não instalados.')
        }

        loader({ text: 'Obtendo certificados...', active: true })

        this.certificados = await BryService.getCertificates()

        loader({ text: '', active: false })

        if (this.certificados.length === 0) {
          this.onError('', 'Nenhum Certificado encontrado.')
        }

        if (this.certificados.length > 1) {
          this.$refs.modalCertificados.show()
        } else {
          this.certificadoSelecionado = this.certificados[0]

          // Anulando certificados obtidos
          this.certificados = null

          await this.submitFiles()
        }
      },

      async assinarDocumentos (documentoId) {
        loader({ text: 'Assinando documentos...', active: true })

        try {
          const { nonce, assinaturasInicializadas } = await BryService.startSigning(
            this.certificadoSelecionado.certificateData,
            [documentoId]
          )

          const assinaturasObj = assinaturasInicializadas.map(({ nonce, messageDigest }) => {
            return BryService.prepareContentForSignature(messageDigest, nonce)
          })

          const { certId } = this.certificadoSelecionado
          const { assinaturas } = await BryService.signBase64Content(certId, assinaturasObj)

          await BryService.endSigning(nonce, assinaturas)

          this.updateSearch('Documento importado e assinado')
        } catch (e) {
          this.documentoId = null

          if (e.description) e.message = e.description

          return this.onError('', `Não foi possível assinar os documentos. \n ${e.message}`)
        }
      },

      // Função para iniciar loader em todas as outras funções de assinar e importar
      startsSignOrImport (text) {
        NProgress.start()
        this.$store.dispatch('auth/loader', { text: text, active: true }).then(()=> {})
      },

      // Função para atualizar busca
      updateSearch (text) {
        this.selectedFiles = []
        this.inputLabel = ''
        this.assinando = false
        NProgress.done()
        this.$store.dispatch('auth/loader', { text: '', active: false }).then(()=> {})
        objSwal.success.title = text
        objSwal.success.text = ''
        return Swal.fire(objSwal.success)
      },
      // Função de retorno de erro
      errorSwal (res) {
        this.fileObj.status = STATUS_ERROR
        this.fileObj.error = res.response.data.error
        objSwal.error.title = ''
        objSwal.error.text = res.response.data.message
        NProgress.done()
        this.$store.dispatch('auth/loader', { text: '', active: false }).then(()=> {})
        Swal.fire(objSwal.error).then(()=> {})
      },

      onError (title, text) {
        loader({ text: '', active: false })

        objSwal.error.title = title
        objSwal.error.text = text
        return Swal.fire(objSwal.error)
      },
    }
  }
</script>

<style lang="scss">
  @import '../../../scss/_utilities/exports';

  .formAddDocs {
    .icon--xxs  {
      fill: white
    }
  }

  .boxAddDocs {
    border: pxToRem(1) dashed $color-dark;

    &_header {
      background-color: $color-dark;

      &_title {
        @extend %titleIcon;
        border: none;
        color: $color-white;

        &:before {
          background-image: url('../../../assets/icons/image-plus-white.svg');
          height: pxToRem(16);
          left: pxToRem(6);
          margin-top: pxToRem(6);
          width: pxToRem(16);
        }
      }
    }

    &_content {
      padding: pxToRem(10);
    }

    &--display-flex{
      display: flex;
    }

    &--self-flex-end{
      align-self: flex-end;
    }
  }
</style>
